import {saveState, loadState} from '../../data/local-storage';
import store from '../store';
import questionsReducer, {getQuestionPointTotal}  from './questions';

import resultsReducer from './results';
import resultsLogicReducer, {getResultsLogicAnswer} from './resultsLogic';
const getInitialState = (loadedState) => {
	const initialState = {
		rootId: loadedState.rootId,
		isLoaded: loadedState.isLoaded || false,
		questions: questionsReducer(loadedState.questions || [], {
			type: 'questions/load',
		}),
		results: resultsReducer(loadedState.results || [], {
			type: 'results/load',
		}, loadedState),
		resultsLogic: resultsLogicReducer(loadedState.resultsLogic || [], {
			type: 'resultsLogic/load'
		}),
		totalPoints: 0,
		activeQuestion: 0
	}
	initialState.activeResult = getActiveResultIndex(initialState);
	return initialState;
}
export function getTotalPoints(state){
	var total = 0;
	state.questions.forEach( q => {
		total += getQuestionPointTotal(q);
	});
	return total;
}
export function getActiveResultIndex(state){
	var matchingResult = getResultsLogicAnswer(state);
	return matchingResult ? state.results.indexOf( matchingResult ) : null;
}

var loadedState = loadState() || {};
var loadedState = {};
var initialState = getInitialState( loadedState );
export default function rootReducer(state = initialState, action) {
	var newState;
	if ( action.type.indexOf('questions/') === 0 ){
		newState = Object.assign({}, state, {
			questions: questionsReducer(state.questions, action, state),
		});
		return newState;
	} else if ( action.type.indexOf('results/') === 0 ){
		newState = Object.assign({}, state, {
			results: resultsReducer(state.results, action, state),
		});
		return newState;
	}
	switch( action.type ){
		case 'load':
			newState = getInitialState({
				rootId: action.payload.rootId,
				resultsLogic: action.payload['results-logic'],
				questions: action.payload.questions,
				results: action.payload.results
			});
			newState.isLoaded = true;
			return newState;
		case 'reset':
			newState = Object.assign({}, state);
			newState.isLoaded = true;
			newState.questions = questionsReducer( newState.questions, {
				type: 'questions/reset'
			})
			newState.results = resultsReducer( newState.results, {
				type: 'results/reset'
			}, newState);
			newState.activeResult = null;
			newState.activeQuestion = 0;
			return newState;
		case 'load_from_endpoint':
			var endpoint = action.payload.restendpoint;
			var rootId = action.payload.rootId;
			if ( state.isLoaded ){
				return state;
			}
			fetch(endpoint).then( r => {
				r.json().then( r => {
					r.rootId = rootId;
					store.dispatch({
						type: 'load',
						payload: r
					})
				})
			});
		case 'set/activeQuestion':
			newState = Object.assign({}, state);
			if ( state.questions[action.payload] ){
				newState.activeQuestion = action.payload;
			}
			return newState;
		case 'set/questionSelection':
			newState = Object.assign({}, state);
			newState.questions = questionsReducer(newState.questions, {
				type: 'questions/question/setSelection',
				payload: action.payload
			});
			newState.totalPoints = getTotalPoints(newState);
			newState.activeResult = getActiveResultIndex(newState);
			return newState;
		case 'set/isLoaded':
			newState = Object.assign({}, state);
			newState.isLoaded = action.payload;
			return newState;
		default:
			return state;
	}
}
